<template>
  <div>
    <div class="info-section">
      <img class="info-img" :src="activeData.img"/>
      <div class="info-text">
        <img class="info-logo" :src="activeData.logo"/>
        <p class="info-name"> {{activeData.name}}</p>
        <p class="info-desc"> {{activeData.desc}}</p>
      </div>
    </div>
    <div class="function-section">
      <div class="inner-box">
        <div class="inner-item" v-for="item in activeData.funList" :class="cusClass[activeData.funList.length]" :key="item.name">
          <span class="icon-box">
            <i :class="'iconfont ' + item.icon"></i>
          </span>
          <p class="item-name"> {{item.name}}</p>
          <p class="item-desc"> {{item.desc}}</p>
        </div>
      </div>
    </div>
    <div class="ad-section">
      <div class="ad-box">
        <div class="preview-box">
          <div class="preview-img">
            <div class="img-normal" :style="{backgroundImage: 'url(' + active.normal + ')'}"></div>
            <div class="img-active" :style="{backgroundImage: 'url(' + active.active + ')'}"></div>
          </div>
        </div>
        <div class="preview-act">
          <p class="title" id="JS_preview_title"> {{active.name}}</p>
          <p class="desc" id="JS_preview_desc"> {{active.desc}}</p>
          <div class="ad-type-list">
            <div v-for="(adType, i) in activeData.adTypeList" :key="i + '_' + adType.name" @click="handleEnter(adType)" :class="{'empty-item': !adType.name, 'ad-type-item': adType.name, 'active': active.name === adType.name}">
              <template v-if="adType.name">
                <i :class="'iconfont ' + adType.icon"></i>
                <p class="ad-name"> {{adType.name}}</p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'resource',
    data() {
      return {
        dataInfo: {
          safe: {
            page: 'safe',
            name: '手机管家',
            desc: 'MIUI系统人手必备，每日必用软件',
            img: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/resource-safe.png',
            logo: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/manager.png',
            funList: [
              {name: 'MIUI系统必备应用', icon: 'iconEMI-61', desc: '使用高频，超强用户粘性，应用分发高曝光；场景化推荐，塑造产品正面品牌形象。'},
              {name: '高转化资源', icon: 'iconEMI-53', desc: '算法推荐，精准投放；应用调性促使用户信任度高，助力下载激活增长'}
            ],
            adTypeList: [
              {name: '体检结果页信息流', icon: 'iconEMI-55', desc: '', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/manager-feed.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/manager-feed-hover.jpg'},
              {name: '安装器应用分发', icon: 'iconEMI-66', desc: '', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/manager-distribute.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/manager-distribute-hover.jpg'}
            ]
          },
          shop: {
            page: 'shop',
            name: '应用商店',
            desc: '千亿级分发平台，多样广告资源触达用户，助力应用快速增长',
            img: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/resource-shop.png',
            logo: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/shop.png',
            funList: [
              {name: '分发渠道主力', icon: 'iconEMI-15', desc: '小米最大的分发渠道，千万级日活，用户认可度高 '},
              {name: '精准触达用户', icon: 'iconEMI-6', desc: '精品、搜索等多种资源位，精准算法推荐触达用户，投放效果显著'},
              {name: '品效结合', icon: 'iconEMI-3', desc: '商店首页、主题活动等资源强势曝光，提升应用影响力'}
            ],
            adTypeList: [
              {name: '精品列表', icon: 'iconEMI-41', desc: '精品塑造行业Top地位，用户认可度高，下载量大', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-list.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-list-hover.jpg'},
              {name: '搜索广告', icon: 'iconEMI-37', desc: '搜索强相关性，下载转化高，引导下载', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-search.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-search-hover.jpg'},
              {name: '搜索富媒体', icon: 'iconEMI-64', desc: '依托于搜索大流量，通过大面积广告展示吸引用户，提升转化', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-rich.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-rich-hover.jpg'},
              {name: '应用相关推荐', icon: 'iconEMI-59', desc: '应用升级界面，安装应用的同时，推荐相关应用', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-recommend.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-recommend-hover.jpg'},
              {name: '首页焦点图', icon: 'iconEMI-38', desc: '进入商店首页核心位置、大尺寸、高曝光', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-focus.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-focus-hover.jpg'},
              {name: '装机必备', icon: 'iconEMI-61', desc: '平台权威推荐，一键便捷安装', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-install.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-indtall-hover.jpg'},
              {name: '排行榜', icon: 'iconEMI-58', desc: '聚焦市场时下热门应用，满足用户猎奇心理', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-brand.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-brand-hover.jpg'},
              {name: '红包专场', icon: 'iconEMI-50', desc: '现金红包吸引用户下载及激活，成本低，激活转化率高', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-redbag.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/shop-redbag-hover.jpg'}
            ]
          },
          video: {
            page: 'video',
            name: '小米视频',
            desc: 'MIUI视频类应用排名第一，聚合全网热门视频，小米最天然的视频广告场景阵地。',
            img: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/resource-video.png',
            logo: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/video.png',
            funList: [
              {name: '天然的视频营销场景', icon: 'iconEMI-21', desc: '汇聚全网最具人气的热门视频，长短视频应有尽有，更生动更形象地传递品牌形象。 '},
              {name: '丰富多样的广告形式', icon: 'iconEMI-30', desc: '品效覆盖、动静结合，丰富多样的广告形式，助力品牌价值全面提升。'},
              {name: '精准多维的受众定向', icon: 'iconEMI-32', desc: '多维度的受众定向，更精准的广告营销。直达目标用户，更快抢占市场。'}
            ],
            adTypeList: [
              {name: 'Banner', icon: 'iconEMI-63', desc: '根据浏览内容偏好推荐相关性广告，融合度高', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-banner.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-banner-hover.jpg'},
              {name: '视频前贴', icon: 'iconEMI-54', desc: '用户收看视频正片前展示的视频 / 图片广告', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-fontpost.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-fontpost-hover.jpg'},
              {name: '视频暂停', icon: 'iconEMI-52', desc: '当用户点击暂停，广告出现', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-pause.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-pause-hover.jpg'},
              {name: '视频角标', icon: 'iconEMI-62', desc: '视频播放时，角标广告停留15s自动消失', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-subscript.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/video-subscript-hover.jpg'}
            ]
          },
          browser: {
            page: 'browser',
            name: '信息流媒体',
            desc: '涵盖小米所有信息流媒体，包括浏览器，想看，内容中心等，拥有系统级入口、图文和视频内容生态和高时长的用户粘性，通过原生信息流广告多角度触达用户',
            img: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/resource-browser.png',
            logo: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/browser.png',
            funList: [
              {name: '高活跃多类型用户集合地', icon: 'iconEMI-9', desc: '集资讯、搜索、阅读、购物、激励资讯、小视频为一体的综合入口，原生信息流广告多角度触达用户 '},
              {name: '系统级入口，内容中心', icon: 'iconEMI-16', desc: '桌面任意一屏上滑，即可唤出桌面信息流，更自然、更便捷、更高频'},
              {name: '精准定位受众人群', icon: 'iconEMI-19', desc: '基于小米大数据能力提供18种人群定向能力，供广告主精准定位受众人群'},
              {name: 'MIUI外流量', icon: 'iconEMI-29', desc: '想看APP作为外发资讯，与小米其他MIUI外媒体一起 触达非MIUI人群'}
            ],
            adTypeList: [
              {name: '信息流大图', icon: 'iconEMI-57', desc: '', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-big.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-big-hover.jpg'},
              {name: '信息流小图', icon: 'iconEMI-65', desc: '', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-small.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-small-hover.jpg'},
              {name: '信息流组图', icon: 'iconEMI-51', desc: '', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-group.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-group-hover.jpg'},
              {name: '信息流视频', icon: 'iconEMI-46', desc: '', normal: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-video.jpg', active: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/preview/feed-video-hover.jpg'},
            ]
          },
        },
        cusClass: ['', 'one', 'two', 'three', 'four'],
        active: null,
        previewImg: '',
      }
    },
    computed: {
      page() {
        const route = this.$route;
        return route.params.type;
      },
      activeData() {
        return this.dataInfo[this.page];
      }
    },
    watch: {
      page() {
        this.active = this.dataInfo[this.page].adTypeList[0];
        this.previewImg = this.active.normal;
      }
    },
    created() {
      this.active = this.dataInfo[this.page].adTypeList[0];
      this.previewImg = this.active.normal;
    },
    methods: {
      handleEnter(adType) {
        if (adType.name) {
          this.active = adType;
          this.previewImg = this.active.active;
        }
      },
      hoverImg() {
        this.previewImg = this.active.active;
      },
      leaveImg() {
        this.previewImg = this.active.normal;
      },
      hashChange(e) {
        let newUrl = e.newURL;
        let hashIndex = newUrl.indexOf('#');
        let hash = newUrl.substring(hashIndex + 1);
        this.page = hash && Object.keys(this.dataInfo).indexOf(hash) > -1 ? hash : 'safe';
        this.active = this.dataInfo[this.page].adTypeList[0];
        this.previewImg = this.active.normal;
      }
    }
  }
</script>
<style lang="scss">
@import '../assets/scss/resource.scss'
</style>